import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin } from 'lucide-react';
export function CtaSection() {
  return <section className="py-32 bg-gym-dark relative overflow-hidden" data-id="element-26">
      {/* Decorative background elements */}
      <div className="absolute inset-0 bg-gradient-to-t from-gym-green/10 to-transparent pointer-events-none" data-id="element-27"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-29">
          <h2 className="text-4xl md:text-6xl font-bold mb-12 uppercase tracking-wide text-white" data-id="element-30">
            Haz clic y reserva tu{' '}
            <span className="text-gym-green" data-id="element-31">clase gratis ahora</span>
          </h2>

          <a href="https://wa.me/51915013918" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-4 bg-gym-green hover:bg-gym-greenHover text-white px-10 py-6 rounded-full font-bold text-2xl md:text-4xl transition-all transform hover:scale-105 shadow-[0_0_40px_rgba(16,185,129,0.5)] mb-16" data-id="element-32">
            <Phone size={40} className="animate-pulse" data-id="element-33" />
            +51 915 013 918
          </a>

          <div className="space-y-8 text-xl md:text-2xl text-gray-300 leading-relaxed font-body italic max-w-3xl mx-auto" data-id="element-34">
            <p className="border-l-4 border-gym-gold pl-6 py-2 text-left bg-gym-charcoal/50 rounded-r-lg" data-id="element-35">
              "El mejor momento para empezar fue hace un año. El segundo mejor
              momento es hoy."
            </p>
          </div>

          <div className="mt-16 flex items-center justify-center gap-3 text-gray-400 bg-gym-charcoalLight/50 p-4 rounded-xl border border-gym-charcoalLight inline-flex mx-auto" data-id="element-36">
            <MapPin size={24} className="text-gym-gold shrink-0" data-id="element-37" />
            <span className="text-sm md:text-base font-medium" data-id="element-38">
              Esquina Av. Brígida Silva de Ochoa con Calle Angélica Palma 195,
              San Miguel 2do Piso, Lima
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}